import { Guardian } from '@xaamin/guardian';

Guardian.define('usuarios.access', (user) => {
  return user.cliente?.servicios?.multi_usuario === true && user.can(['usuario.crear', 'usuario.listar']);
});

Guardian.define('is_connect.access', (user) => {
  return user.cliente?.metadata?.isConnect === true;
});
